import { render, staticRenderFns } from "./BtnThemeSwitcher.vue?vue&type=template&id=c5eaac58&"
import script from "./BtnThemeSwitcher.vue?vue&type=script&lang=js&"
export * from "./BtnThemeSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports